import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  withMargin: {
    margin: theme.spacing(1)
  },
  searchRow: {
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
